(function () {
  function init() {
    const el = document.querySelector('[data-footer-logos]');
    if (!el || typeof Swiper === 'undefined') return;

    const slides = el.querySelectorAll('.swiper-slide');
    if (!slides.length) return;

    new Swiper(el.querySelector('.footer-logos__swiper'), {
      slidesPerView: 3,
      spaceBetween: 32,
      loop: slides.length > 6,
      autoplay: { delay: 2500, disableOnInteraction: false },
      breakpoints: {
        600: { slidesPerView: 4 },
        960: { slidesPerView: 6 },
      },
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
